import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { PermissionsService } from '@core/services/permissions.service';
import { APP_STORE } from '@core/stores/app.store';
import { PermissionsType } from '@shared/models/permissions-type';

export const DEFAULT_ROUTE_GUARD: CanActivateFn = (): boolean => {
  const appStore = inject(APP_STORE);
  const router = inject(Router);
  const permissionsService = inject(PermissionsService);

  const clientId = appStore.selectedClientId();
  const projectId = appStore.selectedProjectId();

  if (clientId && projectId) {
    void router.navigate([
      clientId,
      projectId,
      getAllowedPage(permissionsService)
    ]);

    return false;
  }

  return true;
};

const getAllowedPage = (permissionsService: PermissionsService): string => {
  const canViewInspectionsPage = permissionsService.hasPermissions(
    [PermissionsType.InspectionView, PermissionsType.InspectionViewAssigned],
    undefined,
    false
  );
  const canViewLopPage = permissionsService.hasPermissions(
    [PermissionsType.LopView, PermissionsType.LopViewAssigned],
    undefined,
    false
  );
  const canViewAllItemsPage = permissionsService.hasPermissions(
    [
      PermissionsType.InspectionView,
      PermissionsType.InspectionViewAssigned,
      PermissionsType.LopView,
      PermissionsType.LopViewAssigned
    ],
    undefined,
    false
  );
  const canViewSettingsPage = permissionsService.hasPermissions(
    [
      PermissionsType.AttributeView,
      PermissionsType.AccountView,
      PermissionsType.RoleView,
      PermissionsType.InspectionItemStatusView,
      PermissionsType.InspectionReportCustomSectionView,
      PermissionsType.EmailNotificationView
    ],
    undefined,
    false
  );
  const canViewTemplatesPage = permissionsService.hasPermissions(
    [PermissionsType.InspectionTemplateView],
    undefined,
    false
  );
  const canViewFloorplansPage = permissionsService.hasPermissions(
    [PermissionsType.FloorplanView],
    undefined,
    false
  );

  if (canViewInspectionsPage) {
    return 'inspections';
  }

  if (canViewLopPage) {
    return 'lop';
  }

  if (canViewAllItemsPage) {
    return 'all-items';
  }

  if (canViewTemplatesPage) {
    return 'templates';
  }

  if (canViewFloorplansPage) {
    return 'floorplans';
  }

  if (canViewSettingsPage) {
    return 'settings';
  }

  return '';
};
